var _path, _circle, _circle2, _circle3, _circle4, _circle5, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg02Restaurant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2811 32.0569C22.3962 31.8556 22.5783 31.7015 22.7931 31.6143C28.65 29.2376 32.7803 23.4924 32.7803 16.7826C32.7803 7.94601 25.6168 0.782562 16.7803 0.782562C7.94372 0.782562 0.780273 7.94601 0.780273 16.7826C0.780273 23.5786 5.01733 29.385 10.9939 31.7042C11.2152 31.7901 11.4031 31.9465 11.5209 32.1526L15.1372 38.4811C15.905 39.8247 17.8424 39.8247 18.6101 38.4811L22.2811 32.0569Z",
    fill: "#5746C0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7803,
    cy: 16.7826,
    r: 13.5,
    fill: "#291F50"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7802,
    cy: 16.471,
    r: 9.38177,
    fill: "#E7E6F0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7882,
    cy: 16.471,
    r: 7.97451,
    fill: "#4841A6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7886,
    cy: 16.4793,
    r: 7.50542,
    fill: "#8F87F3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7804,
    cy: 16.4793,
    r: 6.56724,
    fill: "#4841A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0028 13.9151C14.1331 13.6926 14.4187 13.617 14.6421 13.746C14.8674 13.8761 14.9438 14.1647 14.8123 14.3893L14.2212 15.3985C14.1558 15.5102 14.1938 15.6539 14.3059 15.7186C14.417 15.7828 14.559 15.7453 14.624 15.6347L15.2212 14.618C15.3517 14.3958 15.6371 14.3205 15.8602 14.4493C16.0858 14.5795 16.162 14.8686 16.0301 15.0931L15.4419 16.0945C15.3742 16.2097 15.4134 16.358 15.5291 16.4248C15.6442 16.4913 15.7914 16.4518 15.8578 16.3367L16.4411 15.3264C16.5706 15.102 16.8575 15.0252 17.0819 15.1547C17.3063 15.2842 17.3831 15.5711 17.2536 15.7955L16.55 17.0142L16.55 17.0142L16.55 17.0142L16.0809 17.8267C15.6431 18.585 14.7559 18.9221 13.9499 18.6958L12.1228 21.8094L11.3119 21.3412L13.1397 18.2264C12.5441 17.6413 12.3941 16.707 12.8309 15.9504L13.2529 15.2195C13.2546 15.2166 13.2536 15.2129 13.2507 15.2112C13.2478 15.2095 13.2468 15.2058 13.2485 15.2029L14.0028 13.9151Z",
    fill: "#353071"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.598 13.6858C13.7273 13.4609 14.0146 13.3836 14.2392 13.5133C14.4633 13.6427 14.5403 13.929 14.4114 14.1533L13.8254 15.1727C13.7614 15.2841 13.7996 15.4263 13.9109 15.4905C14.0223 15.5549 14.1648 15.5167 14.2291 15.4053L14.7668 14.4739C14.8964 14.2495 15.1833 14.1727 15.4076 14.3022C15.632 14.4317 15.7089 14.7186 15.5793 14.943L15.0424 15.873C14.9776 15.9852 15.016 16.1286 15.1282 16.1933C15.2403 16.2581 15.3837 16.2196 15.4485 16.1075L16.0349 15.0918C16.1644 14.8675 16.4513 14.7906 16.6756 14.9201C16.9 15.0497 16.9769 15.3366 16.8473 15.5609L16.1437 16.7796L16.1437 16.7796L16.1437 16.7797L15.6746 17.5921C15.237 18.3501 14.3505 18.6872 13.5448 18.4616L11.7322 21.571L10.9213 21.1028L12.7343 17.9927C12.138 17.4076 11.9877 16.4727 12.4247 15.7158L12.8928 14.9049C12.8934 14.904 12.8945 14.9037 12.8954 14.9042C12.8963 14.9048 12.8975 14.9044 12.898 14.9035L13.598 13.6858Z",
    fill: "#E7E6F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8621 17.123L15.0719 16.7597C15.1367 16.6475 15.2801 16.6091 15.3923 16.6738C15.5045 16.7386 15.5429 16.882 15.4782 16.9942L15.2684 17.3576C14.9196 17.9618 14.1904 18.2094 13.5579 17.9727C13.4366 17.9273 13.3985 17.7817 13.4633 17.6696C13.5281 17.5574 13.6714 17.5224 13.7961 17.5574C14.1992 17.6709 14.6431 17.5024 14.8621 17.123Z",
    fill: "#ABA9C8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.0569,
    y: 20.8992,
    width: 1.87635,
    height: 2.81453,
    rx: 0.6,
    transform: "rotate(30 11.0569 20.8992)",
    fill: "#353071"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6506,
    y: 20.6646,
    width: 1.87635,
    height: 2.81453,
    rx: 0.6,
    transform: "rotate(30 10.6506 20.6646)",
    fill: "#8F87F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8364 15.8954C16.8078 16.3388 16.9111 16.7808 17.1333 17.1657L17.4962 17.7942C17.9335 18.5516 18.819 18.8888 19.6242 18.6642L21.4133 21.7631L22.2242 21.2949L20.4351 18.1961C21.0326 17.6112 21.1835 16.6754 20.7461 15.9179L20.3833 15.2893C20.1611 14.9045 19.8299 14.594 19.4316 14.3971C18.2797 13.8275 16.9191 14.6131 16.8364 15.8954Z",
    fill: "#353071"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2422 15.6608C17.2136 16.1042 17.317 16.5462 17.5391 16.9311L17.902 17.5596C18.3393 18.3169 19.2247 18.6541 20.0298 18.4296L21.7953 21.4971L22.6062 21.029L20.8409 17.9616C21.4384 17.3767 21.5894 16.4408 21.152 15.6832L20.7891 15.0547C20.5669 14.6699 20.2358 14.3594 19.8374 14.1624C18.6855 13.5929 17.3249 14.3784 17.2422 15.6608Z",
    fill: "#E7E6F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3397 16.1522L20.13 15.7888C20.0652 15.6766 20.1036 15.5332 20.2158 15.4684C20.328 15.4037 20.4714 15.4421 20.5362 15.5543L20.746 15.9176C21.0948 16.5218 20.9447 17.2771 20.4235 17.7065C20.3235 17.7889 20.1784 17.7491 20.1136 17.6369C20.0488 17.5247 20.0902 17.383 20.1829 17.2926C20.4827 17.0002 20.5587 16.5315 20.3397 16.1522Z",
    fill: "#ABA9C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8945,
    y: 21.8047,
    width: 1.87635,
    height: 2.81453,
    rx: 0.2,
    transform: "rotate(-30 20.8945 21.8047)",
    fill: "#353071"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.301,
    y: 21.5701,
    width: 1.87635,
    height: 2.81453,
    rx: 0.2,
    transform: "rotate(-30 21.301 21.5701)",
    fill: "#8F87F3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02Restaurant);
export default __webpack_public_path__ + "static/media/02_restaurant.c43341af72285f53ce62eba13f9d6163.svg";
export { ForwardRef as ReactComponent };